import { getDay as getDayFns } from 'date-fns';

export default function getDay(date: Date): number {
  return getDayFns(date);
}
